export default __webpack_public_path__ + "static/media/first-template.ecc0bcf5.png";